/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TestStepConfigurationDto } from './TestStepConfigurationDto';
export type NumericTestStepConfigurationDto = (TestStepConfigurationDto & {
    unit?: string;
    allowedNumberOfDecimals?: number;
    mode?: NumericTestStepConfigurationDto.mode;
} & {
    mode: NumericTestStepConfigurationDto.mode;
});
export namespace NumericTestStepConfigurationDto {
    export enum mode {
        LESS_THAN = 'LESS_THAN',
        LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
        GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
        GREATER_THAN = 'GREATER_THAN',
        EXACT_VALUE = 'EXACT_VALUE',
        MIN_MAX_RANGE = 'MIN_MAX_RANGE',
        GREATER_THAN_OR_EQUAL_AND_LESS_THAN_RANGE = 'GREATER_THAN_OR_EQUAL_AND_LESS_THAN_RANGE',
        GREATER_THAN_AND_LESS_THAN_OR_EQUALS_RANGE = 'GREATER_THAN_AND_LESS_THAN_OR_EQUALS_RANGE',
        RATE_REPORT = 'RATE_REPORT',
    }
}

